import lotsUserSelectorDialog from './index.vue'; // 导入组件

lotsUserSelectorDialog.install = (Vue) => {
    Vue.component(lotsUserSelectorDialog.name, lotsUserSelectorDialog);
};
export default lotsUserSelectorDialog;
